import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

// servicios
import { SidebarService } from 'src/app/services/sidebar.service';
import { UsuarioService } from 'src/app/services/datos/usuario.service';
import { CambiarPasswordService } from 'src/app/services/cambiar-password.service';

// interfaces
import { IUsuario } from 'src/app/interfaces/usuario';

// librerías
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit, OnDestroy {
  opcionesMenu: any[] = [];
  // CAMBIO PRINCIPAL: Inicializar como false para que no esté expandido al inicio
  userMenuExpanded: boolean = false;

  private sub!: Subscription;

  constructor(
    public sidebarSrv: SidebarService,
    public usuarioSrv: UsuarioService,
    private router: Router,
    private cambiarPswSrv: CambiarPasswordService
  ) { }

  ngOnInit(): void {
    this.opcionesMenu = this.sidebarSrv.menu;

    // Escuchar eventos de expansión, si se pasan desde cualquier otro componente
    this.sub = this.sidebarSrv.menuState$.subscribe(menuId => {
      if (menuId) {
        this.opcionesMenu.forEach(menu => {
          if (menu.id === menuId) {
            console.log('__MENU ENCONTRADO, hacer menu.expanded = true para abrir:', menu);
            menu.expanded = true;
          } else {
            menu.expanded = false;
          }
        });
        // Cerrar menú de usuario cuando se expande un menú principal
        this.userMenuExpanded = false;
      }
    });
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  toggleMenu(menu: any, event?: Event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    menu.expanded = !menu.expanded;

    // Si se está expandiendo este menú, colapsar todos los demás
    if (menu.expanded) {
      this.sidebarSrv.menu.forEach((m: any) => {
        if (m !== menu) {
          m.expanded = false;
        }
      });

      // Cerrar el menú de usuario
      this.userMenuExpanded = false;
    }
  }

  toggleUserMenu(event?: Event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    console.log('--> this.userMenuExpanded ANTES de cambiar', this.userMenuExpanded);
    this.userMenuExpanded = !this.userMenuExpanded;
    console.log('--> this.userMenuExpanded DESPUES de cambiar', this.userMenuExpanded);

    // Si se está expandiendo el menú de usuario, colapsar todos los demás menús
    if (this.userMenuExpanded) {
      this.opcionesMenu.forEach((m: any) => {
        m.expanded = false;
      });

      // Cerrar el menú de opciones
      this.sidebarSrv.menu.forEach((m: any) => {
        m.expanded = false;
      });
    }
  }

  logOut() {
    localStorage.removeItem('token');
    this.router.navigateByUrl('/login');
  }

  getUserFoto() {
    return (this.usuarioSrv.getUserFoto());
  }

  async openChangePasswordModal(user: IUsuario): Promise<void> {
    const success = await this.cambiarPswSrv.showChangePasswordModal(user);

    if (success) {
      console.log('Contraseña cambiada exitosamente');
    }
  }
}